export const DEV = "development";
export const STAGING = "staging";
export const PROD = "production";

export const DEV_URL = "https://complience-dev.nationbetter.uk";
export const STAGING_URL = "https://staging-compliance.nationbetter.uk";
export const PROD_URL = "https://compliance.nationbetter.uk";

export const URLS = {
  [DEV]: DEV_URL,
  [STAGING]: STAGING_URL,
  [PROD]: PROD_URL,
};
